module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component component-backoffice-driver-notification"
  }, [_c('ModalReveal', {
    staticClass: "p-0 m-0"
  }, [_c('a', {
    staticClass: "pr-2 fa fa-send-o",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }), _c('label', [_vm._v("Send Notification"), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.pushNotification($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.subject),
      expression: "body.subject"
    }],
    attrs: {
      "type": "text",
      "placeholder": "subject"
    },
    domProps: {
      "value": (_vm.body.subject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "subject", $event.target.value)
      }
    }
  }), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.content),
      expression: "body.content"
    }],
    attrs: {
      "rows": "6",
      "placeholder": "content"
    },
    domProps: {
      "value": (_vm.body.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "content", $event.target.value)
      }
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.url),
      expression: "body.url"
    }],
    attrs: {
      "type": "text",
      "placeholder": "https url"
    },
    domProps: {
      "value": (_vm.body.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "url", $event.target.value)
      }
    }
  })]), _c('ActionButton', {
    attrs: {
      "action": _vm.pushNotification
    }
  }, [_vm._v("Send")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-72f4a2ea!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/DriverNotification.vue
// module id = 2579
// module chunks = 1